var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyLinkIcon = function SvgCopyLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.811 8a3.81 3.81 0 0 0-2.74 1.172A4.07 4.07 0 0 0 1.938 12c0 1.06.408 2.078 1.135 2.828.36.372.786.667 1.257.867.47.201.973.305 1.482.305h2.906c.534 0 .968.448.968 1s-.434 1-.968 1H5.81a5.7 5.7 0 0 1-2.224-.457 5.8 5.8 0 0 1-1.885-1.3A6.1 6.1 0 0 1 0 12a6.1 6.1 0 0 1 1.702-4.243A5.72 5.72 0 0 1 5.811 6h2.906c.534 0 .968.448.968 1s-.434 1-.968 1zm7.748-1c0-.552.434-1 .969-1h2.905c.763 0 1.519.155 2.224.457a5.8 5.8 0 0 1 1.885 1.3c.54.558.968 1.219 1.26 1.947a6.17 6.17 0 0 1 0 4.592 6 6 0 0 1-1.26 1.947c-.54.557-1.18.999-1.885 1.3a5.7 5.7 0 0 1-2.224.457h-2.905c-.535 0-.969-.448-.969-1s.434-1 .969-1h2.905c.509 0 1.013-.104 1.483-.305.47-.2.897-.495 1.256-.867a4 4 0 0 0 .84-1.297 4.11 4.11 0 0 0 0-3.062 4 4 0 0 0-.84-1.297 3.9 3.9 0 0 0-1.256-.868A3.8 3.8 0 0 0 17.433 8h-2.905c-.535 0-.969-.448-.969-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.78 12c0-.552.433-1 .968-1h7.748c.535 0 .969.448.969 1s-.434 1-.969 1H7.748c-.535 0-.968-.448-.968-1",
    clipRule: "evenodd"
  })));
};
export default SvgCopyLinkIcon;